import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },

  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
    overflowY: 'auto'
  },

  inputContainer: {
    width: '100%',
    paddingBottom: 8,
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
  },

  animalCard: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.app.colors.input.background
  },

  animalInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,

    '& span:first-child': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      fontSize: theme.app.typography.body.fontSize
    },

    '& span:last-child': {
      fontWeight: 500,
      color: '#000',
      fontSize: theme.app.typography.label.fontSize
    }
  },
  noAnimalFound: {
    fontStyle: 'italic',
    color: alpha(theme.palette.primary.main, 0.7),
    textAlign: 'center',
    marginTop: 32
  },

  animalsListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 450,
    overflowY: 'auto'
  }
}))
